// extracted by mini-css-extract-plugin
export default {"doc-item":"q75_x","doc-item-name":"CcG64","doc-link":"O5csZ"};